module.exports = __webpack_public_path__ + "img/01.4c010f22.jpg";